<template>
    <div class="main-content"></div>
</template>

<script>
export default {
    name: 'Home',
}
</script>
